// localStorage key for the Lead Finder extension install-nudge banner. We store
// the auth token that was active when the user last dismissed (X) or clicked
// "Install now". The banner re-appears on the next fresh login (which mints a
// new token) and is never shown once the free credits have been claimed.
//
// The auth token itself lives for 30 days (cookie max-age in shared/utils/token),
// so a dismissed banner also re-nudges roughly every ~30 days — whenever the
// token expires and the user logs in again.
export const LEAD_FINDER_EXTENSION_BANNER_DISMISSED_TOKEN_KEY =
  'leadFinderExtensionBannerDismissedForToken';
